import React from 'react'
import { Room } from '../../types'
import { useTranslation } from 'react-i18next';
import { FaBed, FaHashtag } from 'react-icons/fa';
import { MdSingleBed, MdOutlineKingBed, MdOutlineBedroomChild } from 'react-icons/md';
import { setRooms, setSelectedRooms } from '../../features/home/bookingSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';

const RoomCard = ({ room }: { room: Room }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const { roomIds, selectedRooms } = useSelector((state: RootState) => state.bookingSlice);

    const toggleRoom = () => {
        if (roomIds.includes(room.id)) {
            // REMOVE
            dispatch(setRooms(roomIds.filter(id => id !== room.id)));
            dispatch(
                setSelectedRooms(
                    selectedRooms.filter(r => r.id !== room.id)
                )
            );
        } else {
            // ADD
            dispatch(setRooms([...roomIds, room.id]));
            dispatch(setSelectedRooms([...selectedRooms, room]));
        }
    };



    const hasImage = room.image && room.image.trim() !== '';
    const getRoomIcon = (type: string) => {
        switch (type) {
            case 'Single':
                return <MdSingleBed className="text-lg text-primary inline-block " />;
            case 'Delux':
                return <MdOutlineKingBed className="text-lg text-primary inline-block " />;
            case 'Suite':
                return <MdOutlineBedroomChild className="text-lg text-primary inline-block" />;
            default:
                return <FaBed className="text-lg text-primary inline-block  " />;
        }
    };



    return (
        <div
            onClick={toggleRoom}
            className={`flex flex-col cursor-pointer md:flex-row rounded-xl overflow-hidden shadow-lg transition
                    ${roomIds.includes(room.id)
                    ? 'ring-1 ring-secondry bg-orange-50'
                    : 'bg-secondary'
                }`} >
            <div className="flex flex-col md:flex-row overflow-hidden bg-secondary ">
                <div className="w-full md:w-64 relative overflow-hidden h-48 md:h-[180px]">
                    {roomIds.includes(room.id) && (
                        <span className="absolute top-3 right-3 bg-orange-500 text-white text-xs px-3 py-1 rounded-full shadow">
                            {t('selected')}
                        </span>
                    )}
                    {hasImage ? (
                        <img
                            src={room.image}
                            alt={`Room ${room.roomNumber}`}
                            className="w-full h-full "
                        />
                    ) : (
                        <div className="w-full bg-secondry h-full bg-secondary-foreground flex items-center justify-center gap-2  flex-col text-white text-lg font-semibold">
                            <FaHashtag />
                            <span>{t('room-number')}: {room.roomNumber}</span>
                        </div>
                    )}
                </div>

                <div className="w-full md:w-2/3 p-4 flex flex-col justify-between">
                    <div>
                        <h2 className="text-lg font-semibold mb-1">
                            {t(room.type)} #{room.roomNumber}
                        </h2>
                        <p className="flex gap-1 items-center text-sm text-textSecond mb-2">
                            {getRoomIcon(room.type)}
                            {t('room_description.' + room.type)}
                        </p>

                        {/* Amenities */}
                        <div className="flex flex-wrap gap-2 text-sm text-gray-600">
                            {room.amenities.map((a) => (
                                <div key={a.id} className="flex items-center gap-1">
                                    <img src={a.image} alt={a.title} className="w-4 h-4" />
                                    <span>{t(`${a.title}`)}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Price & Action */}
                    <div className="flex justify-between items-center mt-3">


                        {room.hasOffer ? (
                            <span className=' flex flex-col gap-1'>
                                <span className="line-through text-red-500 text-sm ">
                                    {room.pricePerNight} {room.currencyCode} /{t("per-night")}
                                </span>
                                <span className="text-secondry font-bold">
                                    {Math.round(room.pricePerNight * (1 - room.discount / 100))} {room.currencyCode}/{t("per-night")}
                                </span>
                            </span>
                        ) : (
                            <span className="text-secondry font-bold">
                                {room.pricePerNight} {room.currencyCode}/{t("per-night")}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RoomCard;
